__turbopack_context__.v({
  "contentWrapper": "TemplateShareTabContent-module__zqDWVG__contentWrapper",
  "shareList": "TemplateShareTabContent-module__zqDWVG__shareList",
});
